import { Chip, FormHelperText, MenuItem, Select, Tooltip } from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import useStyles from "../../style/js-style/components/rules/EARuleAccordionStyle";
import { find, get as lodashGet } from "lodash";
import { DefaultSelectProps } from "../../services/common/Constants";
import i18next from "i18next";

const EAMultipleSelectChips = ({
  fieldName,
  options,
  selected,
  placeholder,
  disabled = false
}) => {
  const { classes } = useStyles();
  const formMethods = useFormContext();

  if (!selected || selected.length === 0) {
    return <span className={classes.placeHolder}>{placeholder}</span>;
  }

  const getChipClass = (index) => {
    return selected.length === index + 1 && selected.length % 2 !== 0
      ? classes.largeChip
      : classes.chip;
  };

  const getEntryLabel = (value) => {
    let entry = find(options, { value: value });
    return entry ? entry.label : value;
  };

  return (
    <>
      <div className={classes.chipsContainer}>
        {selected.map((value, index) => {
          return (
            <Tooltip key={index} title={getEntryLabel(value)}>
              <Chip
                className={getChipClass(index)}
                key={value}
                label={getEntryLabel(value)}
                deleteIcon={
                  <img
                    src={process.env.PUBLIC_URL + "/img/icons/cross.svg"}
                    alt="close"
                    onMouseDown={(event) => event.stopPropagation()}
                    className={classes.deleteItemIcon}
                  />
                }
                sx={{
                  borderRadius: 0,
                  backgroundColor: "#F2F3F7",
                  color: "#535362",
                  padding: 0,
                  fontSize: "12px",
                  fontWeight: 500,
                  height: "auto",
                  border: 0,
                  maxWidth: "325px",
                  "& .MuiChip-label": {
                    paddingLeft: "4px",
                    paddingRight: "12px",
                  },
                }}
                onDelete={(event) => {
                  if (!disabled) {
                    event.preventDefault();
                    const newSelected = selected.filter((x) => x !== value);
                    formMethods.setValue(fieldName, newSelected.join(','));
                  }
                }}
              />
            </Tooltip>
          );
        })}
      </div>
    </>
  );
};

const EAMultipleSelectInputCommaSeparated = ({
  fieldName,
  options,
  defaultValue,
  onChange,
  placeholder,
  isRequired,
  variant = "default",
  disabled = false
}) => {
  const formMethods = useFormContext();
  const { classes } = useStyles();
  return (
    <div style={{paddingLeft: variant === "fullSize" ? "16px" : "auto"}}>
      <Controller
        control={formMethods.control}
        name={fieldName}
        defaultValue=""
        rules={{
          validate: (value) => {
            if (isRequired) {
              const isEmpty = value.length === 0;
              if (isEmpty) {
                return i18next.t("infos.required");
              } else {
                formMethods.clearErrors(fieldName);
              }
            }
          },
        }}
        render={({ field }) => (
          <Select
            {...field}
            value={field.value ? field.value.split(',') : []}
            id="ea-multiselect-comma-separated-id"
            multiple
            displayEmpty
            onChange={(event) => field.onChange(event.target.value.join(','))}
            variant="standard"
            MenuProps={DefaultSelectProps.MenuProps}
            className={classes.select}
            style={{
              width: variant === "fullSize" ? "calc(100vw - 775px)" : "100%",
            }}
            disabled={disabled}
            error={!!lodashGet(formMethods.formState.errors, `${fieldName}`)}
            renderValue={(selected) => (
              <EAMultipleSelectChips
                fieldName={fieldName}
                selected={selected.map(String)}
                options={options}
                formMethods={formMethods}
                placeholder={placeholder}
                disabled={disabled}
              />
            )}
          >
            {options?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />

      {!!lodashGet(formMethods.formState.errors, `${fieldName}`) && (
        <FormHelperText className="Mui-error">
          {lodashGet(formMethods.formState.errors, `${fieldName}.message`)}
        </FormHelperText>
      )}
    </div>
  );
};

export default EAMultipleSelectInputCommaSeparated;
